/*
 * File: attendeeList.js
 * Project: educore
 * Created Date: 2019-01-09
 * Author: Raziya S
 *
 */

class AttendeeList {
    // @ngInject
    constructor($state, $rootScope, $scope, $mdMedia, $filter, $mdDialog, localStorageService, authService, activityCons, $stateParams, SchoolLogo, CONSTANTS) {
        let self = this;
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }
        //Object - Basic academic details
        let academicDetails = localStorageService.get("authoringData");

        //String - Teaching plan id
        let qpId = $stateParams.qpId

        //Boolean - Activity created or not
        $scope.isActivityCreated = false

        /*
         * Function to get assigned users
         * 
         * @qpId : String - Id of the question paper
         * 
         *
         */
        authService.callAPI(activityCons.API_GET_QP_DETAILS + qpId, "GET", {}, function(response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    $scope.isLoading = false
                    $scope.questionPaper = response.result.data.details;
                    if ($scope.questionPaper && $scope.questionPaper.students) {
                        $scope.assignedUsers = $scope.questionPaper.students;
                        $scope.assignedUsers.sort(function(a, b) {
                            var textA = a.name.toUpperCase();
                            var textB = b.name.toUpperCase();
                            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                        });
                    }
                } catch (ex) {
                    console.log(ex);
                }
            } else {
               // toastr.error('Network Error. Please try later');
            }
            _.defer(function() {
                $scope.$apply();
            });
        });

        /*
         * Function to go to single student based report
         * 
         * @id : String - Id of the question paper
         * 
         * @return : null
         *
         */
        $scope.gotoStudentReport = (id) => {
            $state.go("studentViewReport", {
                qpId: qpId,
                studentId: id
            })
        }
    }
}

export default AttendeeList



// WEBPACK FOOTER //
// ./src/app/traditionalActivity/controllers/attendeeList.js